import React from 'react'
import { makeStyles } from '@material-ui/core/styles'
import { Box, Button, TextField } from '@mui/material'
import { Form_Error_Msgs } from 'src/utils/constants/BuyPolicyBike'
import { useFormik } from 'formik'
import * as Yup from 'yup'
import BackArrow from 'src/assets/Buy_Policy_Images/arrow.svg'

const ThirdPartyPersonal = (props) => {
  const { setIsPersonal } = props
  const classes = useStyles()

  const initalStateValues = {
    name: '',
    mobileNumber: '',
    email: '',
    address: '',
    pincode: '',
    city: '',
    state: '',
  }
  const thirdPartyPersonalForm = useFormik({
    initialValues: initalStateValues,
    validationSchema: Yup.object({
      name: Yup.string().required(Form_Error_Msgs?.Name_Msg),
      mobileNumber: Yup.string().required(Form_Error_Msgs?.Mobile_Msg),
      email: Yup.string(),
      address: Yup.string().required(Form_Error_Msgs?.Address_Msg),
      pincode: Yup.string().required(Form_Error_Msgs?.Pincode_Msg),
      city: Yup.string().required(Form_Error_Msgs?.City_Msg),
      state: Yup.string().required(Form_Error_Msgs?.State_Msg),
    }),
    onSubmit: (values, { setSubmitting }) => {
      handleSubmit(values, setSubmitting)
    },
    enableReinitialize: true,
  })

  const handleSubmit = (values, setSubmitting) => {
    setSubmitting(true)
  }

  const handleBack = () => {
    setIsPersonal(false)
  }

  return (
    <Box className={classes.personalContainer}>
      <Box className={classes.headingSection}>
        <Box className={classes.headingMain}>
          <img
            src={BackArrow}
            height={'11.41px'}
            width={'16.17px'}
            alt='backArrowImg'
            onClick={handleBack}
          />
          Personal Details
        </Box>
        <Box className={classes.headingTag}>It&apos;s the last step</Box>
      </Box>
      <Box className={classes.basicDetailsSection}>
        <Box className={classes.formHeading}>Please fill your details</Box>
        <Box className={classes.flexRow}>
          <Box>
            <TextField
              id='name'
              name='name'
              size='small'
              placeholder='Name'
              onBlur={thirdPartyPersonalForm.handleBlur}
              onChange={thirdPartyPersonalForm.handleChange}
              value={thirdPartyPersonalForm?.values?.name}
              helperText={
                thirdPartyPersonalForm?.touched?.name &&
                thirdPartyPersonalForm?.errors?.name
              }
              error={
                thirdPartyPersonalForm?.touched?.name &&
                Boolean(thirdPartyPersonalForm?.errors?.name)
              }
              InputProps={{
                className: classes.commonFieldStyle,
              }}
            />
          </Box>
          <Box>
            <TextField
              id='mobileNumber'
              name='mobileNumber'
              size='small'
              placeholder='Mobile Number'
              onBlur={thirdPartyPersonalForm.handleBlur}
              onChange={thirdPartyPersonalForm.handleChange}
              value={thirdPartyPersonalForm?.values?.mobileNumber}
              helperText={
                thirdPartyPersonalForm?.touched?.mobileNumber &&
                thirdPartyPersonalForm?.errors?.mobileNumber
              }
              error={
                thirdPartyPersonalForm?.touched?.mobileNumber &&
                Boolean(thirdPartyPersonalForm?.errors?.mobileNumber)
              }
              InputProps={{
                className: classes.commonFieldStyle,
              }}
            />
          </Box>
          <Box>
            <TextField
              id='email'
              name='email'
              size='small'
              placeholder='Email(optional)'
              onBlur={thirdPartyPersonalForm.handleBlur}
              onChange={thirdPartyPersonalForm.handleChange}
              value={thirdPartyPersonalForm?.values?.email}
              helperText={
                thirdPartyPersonalForm?.touched?.email &&
                thirdPartyPersonalForm?.errors?.email
              }
              error={
                thirdPartyPersonalForm?.touched?.email &&
                Boolean(thirdPartyPersonalForm?.errors?.email)
              }
              InputProps={{
                className: classes.commonFieldStyle,
              }}
            />
          </Box>
        </Box>
      </Box>
      <Box className={classes.addressSection}>
        <Box className={classes.formHeading}>Address</Box>

        <Box>
          <TextField
            id='address'
            name='address'
            size='small'
            placeholder='Full Address'
            onBlur={thirdPartyPersonalForm.handleBlur}
            onChange={thirdPartyPersonalForm.handleChange}
            value={thirdPartyPersonalForm?.values?.address}
            helperText={
              thirdPartyPersonalForm?.touched?.address &&
              thirdPartyPersonalForm?.errors?.address
            }
            error={
              thirdPartyPersonalForm?.touched?.address &&
              Boolean(thirdPartyPersonalForm?.errors?.address)
            }
            InputProps={{
              className: classes.addressField,
            }}
          />
        </Box>

        <Box className={classes.flexRow}>
          <Box>
            <TextField
              id='pincode'
              name='pincode'
              size='small'
              placeholder='Pincode'
              onBlur={thirdPartyPersonalForm.handleBlur}
              onChange={thirdPartyPersonalForm.handleChange}
              value={thirdPartyPersonalForm?.values?.pincode}
              helperText={
                thirdPartyPersonalForm?.touched?.pincode &&
                thirdPartyPersonalForm?.errors?.pincode
              }
              error={
                thirdPartyPersonalForm?.touched?.pincode &&
                Boolean(thirdPartyPersonalForm?.errors?.pincode)
              }
              InputProps={{
                className: classes.commonFieldStyle,
              }}
            />
          </Box>
          <Box>
            <TextField
              id='cityName'
              name='city'
              size='small'
              placeholder='Hyderabad'
              onBlur={thirdPartyPersonalForm.handleBlur}
              onChange={thirdPartyPersonalForm.handleChange}
              value={thirdPartyPersonalForm?.values?.city}
              helperText={
                thirdPartyPersonalForm?.touched?.city &&
                thirdPartyPersonalForm?.errors?.city
              }
              error={
                thirdPartyPersonalForm?.touched?.city &&
                Boolean(thirdPartyPersonalForm?.errors?.city)
              }
              InputProps={{
                className: classes.commonFieldStyle,
              }}
            />
          </Box>
          <Box>
            <TextField
              id='stateId'
              name='state'
              size='small'
              placeholder='Telangana'
              onBlur={thirdPartyPersonalForm.handleBlur}
              onChange={thirdPartyPersonalForm.handleChange}
              value={thirdPartyPersonalForm?.values?.state}
              helperText={
                thirdPartyPersonalForm?.touched?.state &&
                thirdPartyPersonalForm?.errors?.state
              }
              error={
                thirdPartyPersonalForm?.touched?.state &&
                Boolean(thirdPartyPersonalForm?.errors?.state)
              }
              InputProps={{
                className: classes.commonFieldStyle,
              }}
            />
          </Box>
        </Box>
      </Box>
      <Box className={classes.buyNowSection}>
        <Button variant='contained' className={classes.buyNowBtn}>
          BUY NOW
        </Button>
      </Box>
    </Box>
  )
}

export default ThirdPartyPersonal

const useStyles = makeStyles({
  personalContainer: {
    padding: 30,
  },
  headingSection: {
    display: 'flex',
    flexDirection: 'column',
    gap: 5,
  },

  basicDetailsSection: {
    display: 'flex',
    flexDirection: 'column',
    gap: 7,
    marginTop: 20,
    marginBottom: 20,
  },
  addressSection: {
    display: 'flex',
    flexDirection: 'column',
    gap: 15,
    marginTop: 20,
    marginBottom: 20,
  },
  flexRow: {
    display: 'flex',
    flexDirection: 'row',
    gap: 10,
  },
  flexColumn: {
    display: 'flex',
    flexDirection: 'column',
    gap: 10,
  },
  sectionHeading: {},
  buyNowSection: {
    display: 'flex',
    justifyContent: 'center',
    marginTop: 20,
    marginBottom: 110,
  },
  buyNowBtn: {
    width: '153px',
    height: '37px',
    borderRadius: '5px',
    background: 'linear-gradient(180deg, #4DC3E3 0%, #1EA0C4 100%)',
    boxShadow: '0px 5px 8px 0px #4DC3E359',
  },
  headingMain: {
    fontFamily: 'Roboto',
    fontSize: '20px',
    fontWeight: 400,
    lineHeight: '23px',
    letterSpacing: '0em',
    display: 'flex',
    justifyContent: 'flex-start',
    alignItems: 'center',
    gap: 5,
  },
  headingTag: {
    fontFamily: 'Roboto',
    fontSize: '14px',
    fontWeight: 300,
    lineHeight: '16px',
    letterSpacing: '0em',
    marginLeft: '4.3%',
  },
  commonFieldStyle: {
    // marginTop: '1.8vw',
    maxWidth: 170,
    height: '30px',
    '&::placeholder': {
      fontSize: '13px !important',
    },
    fontSize: '13px !important',
    background: '#FFFFFF',
  },
  formHeading: {
    fontFamily: 'Roboto',
    fontSize: '15px',
    fontWeight: 400,
    lineHeight: '17.58px',
    letterSpacing: '0em',
  },
  addressField: {
    width: 530,
    height: '30px',
    '&::placeholder': {
      fontSize: '13px !important',
    },
    fontSize: '13px !important',
    background: '#FFFFFF',
  },
})
